import { FunctionComponent, useState } from 'react'
import clsx from 'clsx'
import {
  Box,
  Typography,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@mui/material'
import Close from '@mui/icons-material/Close'
import InfoOutlined from '@mui/icons-material/InfoOutlined'
import isRepaymentAmount from '../../../../../common/utils/isRepaymentAmount'
import accordionElementStyles from './accordionElement.styles'

type AccordionElementProps = {
  index: number
  title: string
  translatedTitle: JSX.Element | string
  classes?: string
  price: string | number
  suffix: JSX.Element | ''
  value: string
}

const AccordionElement: FunctionComponent<AccordionElementProps> = ({
  index,
  title,
  translatedTitle,
  classes,
  price,
  suffix,
  value,
}) => {
  const [expand, setExpand] = useState<boolean>(false)
  const toggleAcordion = () => {
    setExpand(prev => !prev)
  }

  const styles = accordionElementStyles()

  return (
    <Accordion elevation={0} expanded={expand}>
      <AccordionSummary
        id="fcExpandTooltip"
        expandIcon={expand ? <Close /> : <InfoOutlined />}
        onClick={toggleAcordion}
      >
        <Typography
          component="span"
          className={classes}
          data-test={`summary:finance_breakdown_tooltip_title_${index}`}
        >
          {translatedTitle}
        </Typography>
        {value && (
          <Box
            className={clsx([
              styles.breakdownPrice,
              {
                [styles.repaymentAmount]: isRepaymentAmount(title),
              },
            ])}
          >
            {price}
            {suffix}
          </Box>
        )}
      </AccordionSummary>
      <AccordionDetails className={styles.breakdownSectionSummary}>
        <Typography>{title}</Typography>
      </AccordionDetails>
    </Accordion>
  )
}

export default AccordionElement
